<template>
<div class="wrapper">
    <the-nav-bar :title="$t('global.noticeListTitle')" />
    <div class="title-wrapper" v-for="item in list" :key="item.id"  @click="goDetail(item.id)">
        <svg class="icon-left">
        <use xlink:href="#icon-global-dot" />
        </svg>
        <div class="title">
         {{item[prefix+'title']}}
        </div>
       <svg class="icon-right">
        <use xlink:href="#icon-global-right" />
        </svg>
    </div>
</div>
</template>

<script>
import TheNavBar from '@/components/the-nav-bar';
import getTigaNotice from '@/api/get-tiga-notice.js';
import { mapState } from 'vuex';

export default {
  name: 'notice-bar',
  components: {
    TheNavBar,
  },
  data() {
    return {
      list: {},
    };
  },
  computed: {
    ...mapState({
      navLang: state => state.navLang,
      tigaNotice: state=> state.tigaNotice,
      prefix(){
        if(this.navLang=='zh-cn'){
          return '';
        }
        return this.navLang+'_';
      },
    }),
  },
  mounted() {
    if(!this.tigaNotice){
      getTigaNotice()
        .then(data=>{
          this.list = data.data;
          this.$store.commit('setTigaHome', {
            tigaNotice: this.list,
          });
        });
    }
    this.list = this.tigaNotice;
  },
  methods:{
    goDetail(id){
      this.$router.push(`/tigaNotice/detail?id=${id}`);
    },
  },
};

</script>

<style lang="stylus" scoped>
.title-wrapper 
  display: inline-flex;
  align-items: flex-end;
  border: 0.27vw solid #eaf1f3;
  border-top-style: hidden;
  border-left-style: hidden;
  border-right-style: hidden;
  margin: 0 4.8vw;
  height: 13.8vw;
  padding-bottom: 2.38vw;
.icon-left 
  width: 3.2vw;
  height: 3.2vw;
  padding-bottom: 0.58vw;
.title
  width: 78vw;
  padding-left: 1.68vw;
  padding-right: 1.68vw;
  padding-bottom: 0.28vw;
  font-size: 3.68vw;
  color: #2c3133;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;

.icon-right 
  width: 3.2vw;
  height: 3.2vw;
  padding-bottom: 0.68vw;
</style>
